export const CompanyState = {
    archived: 'archived',
    active: 'active'
}